import { useEffect, useState } from "react";
import { idbGetFile } from "@/utils/idbFiles";

export function useIdbObjectUrl(idbKey: string | null) {
  const [url, setUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let objectUrl: string | null = null;

    async function run() {
      setUrl(null);
      if (!idbKey) return;
      setLoading(true);
      try {
        const stored = await idbGetFile(idbKey);
        if (cancelled) return;
        if (!stored) {
          setUrl(null);
          return;
        }
        objectUrl = URL.createObjectURL(stored.blob);
        setUrl(objectUrl);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    run();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [idbKey]);

  return { url, loading };
}
